
    <form [formGroup]="addEditFormDetails" (ngSubmit)="saveOrUpdate()" RestrictFocus>
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-grid-row bottom-10-margin">
          <div class="ui-grid-col-4"><label>{{ 'common.classification_code' | translate}}</label></div>
          <div class="ui-grid-col-8"><input formControlName="code" pInputText/></div>
        </div>
        <div class="ui-grid-row bottom-10-margin">
          <div class="ui-grid-col-4"><label>{{ 'common.classification_description' | translate}}</label></div>
          <div class="ui-grid-col-8"><input formControlName="description" pInputText/></div>
        </div>
      </div>
      <p-footer>
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
          <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
                  [disabled]="!addEditFormDetails.valid || !addEditFormDetails.dirty"
                  [label]="'common.add_classification' | translate"></button>
        </div>
      </p-footer>
    </form>
  


// WEBPACK FOOTER //
// ./src/app/views/administration/classification/classification-details-form.component.ts.ClassificationDetailsForm2Component.html